import { cx } from '@linaria/core';
import { breakpoints } from '@ui/css';
import { Search } from '@ui/kit';
import { HideFor, ShowFor } from '@utils/react';
import { MobileSearch } from '../../../atoms/search.mobile.js';
import { heading, header } from '../../shared.header.style.js';
import { searchCls, headerCls } from './topbar.student.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function StudentHeader(props) {
  const headingLabel = !props.filterOptions.query ? "Mine forløb" : "Søgeresultater";
  return /*#__PURE__*/jsxs("header", {
    className: cx(header, headerCls),
    children: [/*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx("div", {
        className: searchCls
      })
    }), /*#__PURE__*/jsx("h1", {
      className: heading,
      children: headingLabel
    }), /*#__PURE__*/jsx(ShowFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx(MobileSearch, {
        label: "S\xF8g i forl\xF8b",
        onQueryChange: props.filterCallbacks.onQueryChange
      })
    }), /*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx(Search, {
        theme: "local",
        debounceMs: 350,
        compact: true,
        className: searchCls,
        "aria-label": "S\xF8g i forl\xF8b",
        placeholder: "S\xF8g i forl\xF8b",
        onQueryChange: props.filterCallbacks.onQueryChange
      })
    })]
  });
}

export { StudentHeader };
//# sourceMappingURL=topbar.student.js.map
